import styled from '@emotion/styled';
import {has} from 'lodash';

const InputPageContainer = styled.div`
  border-radius: ${props => !has(props.theme, 'blockBorderRadius') ? '10' : props.theme.blockBorderRadius}px;
  border: 1px solid;
  border-color: ${props => props.theme.borderColor};
  background-color: ${props => props.theme.cardColor};
  padding: 32px;
  margin: 40px 0 24px;
  
  @media ${(props)=> props.theme.mobile} {
    border-style: none;
    padding: 0;
  }
`;

export default InputPageContainer;
